class Result {
	static ok(value) {
		return { ok: true, value };
	}

	static error(error) {
		const message = (error && error.message) ? String(error.message) : String(error);
		return { ok: false, error, message };
	}
}

export default Result;




// WEBPACK FOOTER //
// ./src/utils/serviceResultPattern.js